/* angular:styles/component:css;51efdb292f0ad764012c30a1b4ba55b997f65615306bf1a94e4996b96cf06138;/src/src/app/shared/components/formly/formly-field-checkbox-image/formly-field-checkbox-with-image.ts */
.center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 10rem;
  height: auto;
}
.resize-image {
  max-width: 20rem;
  height: auto;
}
.max-width-image {
  max-width: 100%;
  height: auto;
}
.input-box {
  border: 0.1em solid var(--ion-color-dark);
  border-radius: 0.125rem;
  width: 100%;
  padding-left: 0.5rem;
  --min-height: auto;
  --border-color: var(--ion-color-medium);
  transition: border-color 0.3s;
}
.disabled-sub-field {
  pointer-events: none;
  opacity: 0.5;
}
.help-icon {
  vertical-align: middle;
  font-size: 1.1em;
  margin-left: 0.25rem;
  color: var(--ion-color-medium-shade);
  cursor: help;
}
@media (max-width: 600px) {
  .resize-image {
    max-width: 10rem;
    height: auto;
  }
}
/*# sourceMappingURL=formly-field-checkbox-with-image.css.map */
